module.exports = function ($searchRendering) {
    $searchRendering.on('click', '.search-rendering__back-to-top', function (e) {
        var $searchInput = $(e.target).closest('.search-rendering').find('.search-control__search-input').first();
        window.scrollTo({ top: $searchInput.offset().top - 80, behavior: 'smooth' });
        setTimeout(function ($searchInput) {
            $searchInput.focus();
        }, 1000, $searchInput);
    });
};